export const ACTIVE_PROJECT_ID_STORAGE_KEY = "currentProjectId";

export const getActiveProjectId = () => {
  if (typeof localStorage === "undefined") return null;
  const projectId = localStorage.getItem(ACTIVE_PROJECT_ID_STORAGE_KEY);
  return projectId || null;
};

export const setActiveProjectId = (projectId) => {
  if (typeof localStorage === "undefined") return;

  if (projectId) {
    localStorage.setItem(ACTIVE_PROJECT_ID_STORAGE_KEY, projectId);
  } else {
    localStorage.removeItem(ACTIVE_PROJECT_ID_STORAGE_KEY);
  }
};

export const clearActiveProjectId = () => {
  setActiveProjectId(null);
};

// Playground-scoped project selection. Independent from the global active
// project (currentProjectId) so the playground can scope its conversations
// without touching the app-wide project switcher.
export const PLAYGROUND_PROJECT_ID_STORAGE_KEY = "playgroundProjectId";

export const getPlaygroundProjectId = () => {
  if (typeof localStorage === "undefined") return null;
  return localStorage.getItem(PLAYGROUND_PROJECT_ID_STORAGE_KEY) || null;
};

export const setPlaygroundProjectId = (projectId) => {
  if (typeof localStorage === "undefined") return;

  if (projectId) {
    localStorage.setItem(PLAYGROUND_PROJECT_ID_STORAGE_KEY, projectId);
  } else {
    localStorage.removeItem(PLAYGROUND_PROJECT_ID_STORAGE_KEY);
  }
};

export const ACTIVE_ORGANIZATION_ID_STORAGE_KEY = "currentOrganizationId";

// The org the requests are actually scoped to. Cleared in a personal
// workspace, where no X-Organization-ID header is sent at all.
export const getActiveOrganizationId = () => {
  if (typeof localStorage === "undefined") return null;
  return localStorage.getItem(ACTIVE_ORGANIZATION_ID_STORAGE_KEY) || null;
};

/**
 * @typedef {Object} RequestScope
 * @property {string | null} [organizationId]
 * @property {string | null} [projectId]
 */

/**
 * @param {string | null} organizationId
 * @returns {RequestScope}
 */
export const createProjectManagementRequestScope = (organizationId) => ({
  organizationId: organizationId || null,
  projectId: null,
});

/**
 * @param {RequestScope} [scope]
 * @returns {Record<string, string>}
 */
export const getRequestScopeHeaders = (scope = {}) => {
  const headers = {};

  const currentOrgId = Object.prototype.hasOwnProperty.call(
    scope,
    "organizationId",
  )
    ? scope.organizationId
    : getActiveOrganizationId();
  if (currentOrgId) {
    headers["X-Organization-ID"] = currentOrgId;
  }

  const currentProjectId = Object.prototype.hasOwnProperty.call(
    scope,
    "projectId",
  )
    ? scope.projectId
    : getActiveProjectId();
  if (currentProjectId) {
    headers["X-Project-ID"] = currentProjectId;
  }

  return headers;
};
